// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1%;
  border-bottom: 2px solid #2c53a0;
  background-color: #2c53a0;
  width: 100vw;
  height: auto;
  max-height: 130px;
}
nav .menuSection {
  display: flex;
  align-items: center;
  gap: 20px;
}
nav .menuSection .switchZoneLabel {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: aliceblue;
  color: black;
  border-radius: 5%;
  padding: 5px 12px;
  font-weight: 400;
}
nav img {
  filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.8));
  height: 150px;
}
nav .icons {
  display: flex;
  justify-content: space-evenly;
  width: 60%;
  position: absolute;
  right: 2%;
}
nav .icons p {
  color: #fff;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
  position: relative;
  cursor: pointer;
}
nav .icons p span {
  margin-top: 0.5rem;
}
nav .icons p:hover {
  transform: scale(1.1);
}
nav .icons p img {
  width: 20%;
  filter: none;
  margin-top: 5%;
}
nav .icons p .hols__request {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #bb0000;
  color: #fff;
  border-radius: 50%;
  width: 1.2vw;
  height: 1.2vw;
  text-align: center;
}
nav .icons a:hover {
  transform: scale(1.1);
}

footer {
  width: 100vw;
  background-color: #2c53a0;
  text-align: center;
  height: 5vh;
}
footer p {
  margin: auto;
}

@media (max-width: 600px) {
  nav {
    height: 12vh;
    justify-content: flex-start;
  }
  nav img {
    width: 50%;
    height: auto;
    margin-right: 0;
  }
  nav .mobile__icons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
  }
}
@media (min-width: 601px) and (max-width: 1380px) {
  nav img {
    width: 30%;
  }
  nav .icons {
    width: 70%;
  }
  nav .icons p span {
    font-size: 0.6rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  nav img {
    width: 20%;
  }
  nav .icons {
    width: 90%;
  }
  nav .icons p span {
    font-size: 0.6rem;
  }
}
#hols {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #bb0000;
  color: #fff;
  border-radius: 50%;
  width: 1.2vw;
  height: 1.2vw;
  text-align: center;
}
@media (max-width: 600px) {
  #hols {
    width: 6vw;
    height: 6vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/styles/navbar.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;ED6GI,aAAA;EACA,mBAAA;EACA,8BAAA;EC7GF,WAAA;EACA,gCAAA;EACA,yBDNU;ECOV,YAAA;EACA,YAAA;EACA,iBAAA;AAMF;AAJE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAMJ;AALI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAON;AAJE;EACE,sDAAA;EACA,aAAA;AAMJ;AAJE;EACE,aAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAMJ;AALI;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAON;AANM;EACE,kBAAA;AAQR;AANM;EACE,qBAAA;AAQR;AANM;EACE,UAAA;EACA,YAAA;EACA,cAAA;AAQR;AANM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBDzDA;EC0DA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAQR;AALI;EACE,qBAAA;AAON;;AAFA;EACE,YAAA;EACA,yBD7EU;EC8EV,kBAAA;EACA,WAAA;AAKF;AAJE;EACE,YAAA;AAMJ;;AAFA;EACE;IACE,YAAA;IACA,2BAAA;EAKF;EAJE;IACE,UAAA;IACA,YAAA;IACA,eAAA;EAMJ;EAJE;IDmCA,aAAA;IACA,mBAAA;IACA,2BAAA;ICnCE,kBAAA;EAQJ;AACF;AALA;EAEI;IACE,UAAA;EAMJ;EAJE;IACE,UAAA;EAMJ;EAJM;IAEE,iBAAA;EAKR;AACF;AAAA;EAEI;IACE,UAAA;EACJ;EACE;IACE,UAAA;EACJ;EACM;IACE,iBAAA;EACR;AACF;AAKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBDpIM;ECqIN,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAHF;AAIE;EAVF;IAWI,UAAA;IACA,WAAA;EADF;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import \"../variables.scss\";\n\nnav {\n  @include rowBetween;\n  padding: 1%;\n  border-bottom: 2px solid $nitroDark;\n  background-color: $nitroDark;\n  width: 100vw;\n  height: auto;\n  max-height: 130px;\n\n  .menuSection {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    .switchZoneLabel {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: aliceblue;\n      color: black;\n      border-radius: 5%;\n      padding: 5px 12px;\n      font-weight: 400;\n    }\n  }\n  img {\n    filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.8));\n    height: 150px;\n  }\n  .icons {\n    display: flex;\n    justify-content: space-evenly;\n    width: 60%;\n    position: absolute;\n    right: 2%;\n    p {\n      color: #fff;\n      font-size: 1rem;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      font-weight: 400;\n      position: relative;\n      cursor: pointer;\n      span {\n        margin-top: 0.5rem;\n      }\n      &:hover {\n        transform: scale(1.1);\n      }\n      img {\n        width: 20%;\n        filter: none;\n        margin-top: 5%;\n      }\n      .hols__request {\n        position: absolute;\n        top: 0;\n        right: 0;\n        background-color: $error;\n        color: #fff;\n        border-radius: 50%;\n        width: 1.2vw;\n        height: 1.2vw;\n        text-align: center;\n      }\n    }\n    a:hover {\n      transform: scale(1.1);\n    }\n  }\n}\n\nfooter {\n  width: 100vw;\n  background-color: $nitroDark;\n  text-align: center;\n  height: 5vh;\n  p {\n    margin: auto;\n  }\n}\n\n@media (max-width: $mobile) {\n  nav {\n    height: 12vh;\n    justify-content: flex-start;\n    img {\n      width: 50%;\n      height: auto;\n      margin-right: 0;\n    }\n    .mobile__icons {\n      @include rowStart;\n      position: relative;\n    }\n  }\n}\n@media (min-width: 601px) and (max-width: 1380px) {\n  nav {\n    img {\n      width: 30%;\n    }\n    .icons {\n      width: 70%;\n      p {\n        span {\n          // display: none;\n          font-size: 0.6rem;\n        }\n      }\n    }\n  }\n}\n@media (min-width: $smallLaptopMin) and (max-width: $smallLaptopMax) {\n  nav {\n    img {\n      width: 20%;\n    }\n    .icons {\n      width: 90%;\n      p {\n        span {\n          font-size: 0.6rem;\n        }\n      }\n    }\n  }\n}\n\n#hols {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: $error;\n  color: #fff;\n  border-radius: 50%;\n  width: 1.2vw;\n  height: 1.2vw;\n  text-align: center;\n  @media (max-width: $mobile) {\n    width: 6vw;\n    height: 6vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
